import { FC } from 'react'
import { GenderType, IconPaths } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { AtendimentoView } from '../../../../atendimento/core/_models'
import { idadeEmAnos } from '../../core/paciente'
import styles from '../../Prescricao.module.scss'
import { Icone } from '../comum/Icone'
import { Button } from 'app/components'

type IProps = {
  atendimento?: AtendimentoView
  alergias: string[]
  onAtestados: () => void
}

export const CabecalhoPaciente: FC<IProps> = ({ atendimento, alergias, onAtestados }) => {
  const { t } = useT()
  const pessoa = atendimento?.paciente?.pessoa
  const nome = pessoa?.nome ?? atendimento?.paciente?.nome ?? ''
  const idade = idadeEmAnos(pessoa?.dataNascimento)
  const sexo =
    pessoa?.sexo === GenderType.Masculino
      ? t('prescricao.paciente.masculino')
      : pessoa?.sexo === GenderType.Feminino
      ? t('prescricao.paciente.feminino')
      : undefined
  const hoje = new Date().toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

  return (
    <section
      className='card card-bordered mb-5'
      aria-label={t('prescricao.paciente.aria', { nome })}
    >
      <div className='card-body d-flex flex-wrap align-items-center column-gap-12 row-gap-5 py-5'>
        <div className='d-flex flex-column'>
          <span className='fs-4 fw-bold'>{nome}</span>
          <span className={styles.textoSecundario}>
            {[idade !== undefined && t('prescricao.paciente.idade', { idade }), sexo]
              .filter(Boolean)
              .join(' · ')}
          </span>
        </div>

        <dl className='d-flex flex-wrap column-gap-10 row-gap-4 m-0'>
          <div>
            <dt className={`fs-8 fw-bold text-uppercase ${styles.textoSecundario}`}>
              {t('prescricao.paciente.alergias')}
            </dt>
            <dd className='m-0 fw-semibold d-flex flex-wrap gap-1'>
              {alergias.length > 0
                ? alergias.map((alergia) => (
                    <span key={alergia} className={`${styles.selo} ${styles.seloControle}`}>
                      <Icone icone={IconPaths.Alert} />
                      {alergia}
                    </span>
                  ))
                : t('prescricao.paciente.sem_alergias')}
            </dd>
          </div>
          <div>
            <dt className={`fs-8 fw-bold text-uppercase ${styles.textoSecundario}`}>
              {t('prescricao.paciente.data')}
            </dt>
            <dd className='m-0 fw-semibold'>{hoje}</dd>
          </div>
        </dl>

        <Button size='btn-sm' variant='secondary-outline' className='ms-auto' onClick={onAtestados}>
          {t('prescricao.paciente.atestados')}
        </Button>
      </div>
    </section>
  )
}
